module.exports = __webpack_public_path__ + "images/Mail box_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Mail box_hover.png
// module id = 387
// module chunks = 0 1